<template>
  <el-popover placement="bottom-end" width="420" trigger="click" title="How these are calculated">
    <div class="calculation-definitions">
      <div v-for="item in definitions" :key="item.label" class="calculation-definitions__item">
        <strong>{{ item.label }}</strong>
        <p>{{ item.description }}</p>
      </div>
    </div>

    <el-button type="text" slot="reference" class="calculation-help-link" title="How these are calculated">
      <i class="el-icon-info" style="color: #606266; font-size: 14px; margin-bottom: 4px"></i>
    </el-button>
  </el-popover>
</template>

<script>
  const CODER_DEFINITIONS = [
    {
      label: 'Records With Findings',
      description: 'A record with findings and is either Ready for Coder or Completed.'
    },
    {
      label: 'Waiting For Coder',
      description: "A record with findings that is Ready for Coder, where there is no rebuttal yet or the last comment is not from the record's coder."
    },
    {
      label: 'Coder Disagrees',
      description: 'A record with findings where the coder submitted a rebuttal that disagrees with one or more findings.'
    },
    {
      label: 'Waiting For Auditor',
      description: 'A record with a rebuttal where an auditor response is required and the auditor has not yet responded (the last response is not from the auditor).'
    },
    {
      label: 'Records Completed',
      description: 'A record with status Completed and has at least one finding.'
    }
  ]

  const LEVEL2_DEFINITIONS = [
    {
      label: 'Records With Findings',
      description: 'A record with findings and is either Ready for Coder or Completed.'
    },
    {
      label: 'Waiting For Original Auditor',
      description: "A record with findings that is Ready for Coder, where there is no rebuttal yet or the last comment is not from the record's original auditor."
    },
    {
      label: 'Original Auditor Disagrees',
      description: 'A record with findings where the original auditor submitted a rebuttal that disagrees with one or more findings.'
    },
    {
      label: 'Waiting For Level 2 Auditor',
      description: 'A record with a rebuttal where a Level 2 auditor response is required and the Level 2 auditor has not yet responded (the last response is from the original auditor).'
    },
    {
      label: 'Records Completed',
      description: 'A record with status Completed and has at least one finding.'
    }
  ]

  export default {
    name: 'RebuttalCalculationsHelp',

    props: {
      isLevel2Audit: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      definitions() {
        return this.isLevel2Audit ? LEVEL2_DEFINITIONS : CODER_DEFINITIONS
      }
    }
  }
</script>

<style scoped>
  .calculation-help-link {
    padding: 0;

    color: #000;

    font-size: 18px;
  }

  .calculation-definitions__item {
    margin-bottom: 12px;
  }

  .calculation-definitions__item:last-child {
    margin-bottom: 0;
  }

  .calculation-definitions__item p {
    margin: 4px 0 0;

    color: #606266;

    line-height: 1.5;
  }
</style>
